/**
 * `useDebounce`: returns `value` once it has stayed unchanged for `delay` milliseconds; each change
 * restarts the timer. No importer in this repo.
 */
import { useState, useEffect } from "react";

const useDebounce = (value: any, delay: number): any => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => clearTimeout(handler);
	}, [value, delay]);

	return debouncedValue;
};

export default useDebounce;
